import { useEffect } from 'react';
import { useStore, useStoreActions, useStoreStatic } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { defaultFeatureFlagsKey } from '~/store/store.utils';
/** Automatically fetches feature-flags for the relevant businessId, if they weren't already fetched. */ export default function FeatureFlagsFetcher() {
    const { ff: { fetchFeatureFlags } } = useStoreActions();
    const businessId = useStore(selectors.ff.ffBusinessId);
    const { getState } = useStoreStatic();
    useEffect(()=>{
        // Check the actual target feature flags directly (not through selector with fallback)
        const targetBusinessId = businessId || defaultFeatureFlagsKey;
        const targetFF = getState().ff.featureFlags[targetBusinessId];
        // Only fetch if the target FF doesn't exist, isn't loading, and has no error
        if (!targetFF || targetFF.data === null && !targetFF.loading && !targetFF.error) {
            fetchFeatureFlags(businessId);
        }
    }, [
        businessId,
        fetchFeatureFlags,
        getState
    ]);
    return null;
}
